<div class="event-fab event-fab--top event-fab--end">
  <button
    type="button"
    class="event-fab-button"
    [class.event-fab-button--success]="colour === 'success'"
    [class.event-fab-button--secondary]="colour === 'secondary'"
    (click)="buttonClick.emit()">
    <app-display-icon [icon]="icons.checkBold"></app-display-icon>
    <label class="number">{{count}}</label>
    @if (type === 'AO') {
      <label class="text-0">Auto</label>
      <label class="text-1">Orders</label>
    } @else {
      <label class="text-0">Stock</label>
      <label class="text-1">Updates</label>
    }
    <label class="text-2">Successful</label>
  </button>
</div>
